import { Box } from '@mui/material';
import { useEffect, useState } from 'react';
import ChatSidebar from './ChatSidebar';
import ChatPage from './index';
import { apiFetch } from 'utils/api';

export default function ChatLayout() {
  const [chats, setChats] = useState([]);
  const [selectedChatId, setSelectedChatId] = useState(null);

  useEffect(() => {
    loadChats();
  }, []);

  const loadChats = async () => {
    try {
      const data = await apiFetch('/chats');
      setChats(data || []);
      if (data?.length && !selectedChatId) setSelectedChatId(data[0].id);
    } catch (e) {
      console.error('Failed to load chats', e);
    }
  };

  const updateChatTitle = (chatId, title) => {
    setChats((prev) => prev.map((chat) => (chat.id === chatId ? { ...chat, title } : chat)));
  };

  const handleNewChat = async () => {
    setSelectedChatId(null);
  };

  const handleSelectChat = (chatId) => {
    setSelectedChatId(chatId);
  };

  const handleDeleteChat = async (chatId) => {
    try {
      // adjust endpoint if yours is different
      await apiFetch(`/chats/${chatId}`, { method: 'DELETE' });

      setChats((prev) => prev.filter((c) => c.id !== chatId));

      // if deleted chat was selected, switch to another
      if (selectedChatId === chatId) {
        const remaining = chats.filter((c) => c.id !== chatId);
        setSelectedChatId(remaining.length ? remaining[0].id : null);
      }
    } catch (e) {
      console.error('Delete failed', e);
    }
  };

  const handleRenameChat = async (chatId, newTitle) => {
    const title = (newTitle || '').trim();
    if (!title) return;

    try {
      //  adjust endpoint if yours is different
      const updated = await apiFetch(`/chats/${chatId}`, {
        method: 'PATCH',
        body: JSON.stringify({ title })
      });

      // update UI list immediately
      setChats((prev) => prev.map((c) => (c.id === chatId ? { ...c, title: updated?.title ?? title } : c)));
    } catch (e) {
      console.error('Rename failed', e);
    }
  };

  const selectedChat = chats.find((c) => c.id === selectedChatId);

  return (
    <Box
      sx={{
        display: 'flex',
        height: '100%'
      }}
    >
      <Box
        sx={{
          width: 300,
          height: '100vh',
          borderRight: '1px solid rgba(0,0,0,0.08)',
          overflowY: 'auto'
        }}
      >
        <ChatSidebar
          chats={chats}
          selectedChatId={selectedChatId}
          onNewChat={handleNewChat}
          onSelectChat={handleSelectChat}
          onRenameChat={handleRenameChat}
          onDeleteChat={handleDeleteChat}
        />
      </Box>
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          height: '100vh'
          // overflow: 'hidden'
        }}
      >
        <ChatPage
          chatId={selectedChatId}
          hasChats={chats.length > 0}
          chatTitle={selectedChat?.title}
          onAutoRename={updateChatTitle}
          onChatCreated={(chat) => {
            setChats((prev) => [chat, ...prev]);
            setSelectedChatId(chat.id);
          }}
        />
        {/* </Box> */}
      </Box>
    </Box>
  );
}
